/* REFURB AVENUE — contextual catalogue, Shopify live search and URL-based filters. */
(() => {
  if (window.raCatalogueInstalled) return;
  window.raCatalogueInstalled = true;
  const facets = window.RAFacets;
  const navigationRequests = new Map();
  const loadNavigation = url => {
    if (!navigationRequests.has(url)) navigationRequests.set(url, fetch(url, {credentials: 'same-origin'}).then(r => { if (!r.ok) throw new Error('Catalogue indisponible'); return r.json(); }));
    return navigationRequests.get(url);
  };
  const escape = value => String(value ?? '').replace(/[&<>"']/g, ch => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[ch]));
  const conditionLabel = value => {
    const label = String(value ?? '');
    const normalized = label.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
    if (normalized.includes('reconditionn') && (normalized.includes('etat neuf') || normalized.includes('comme neuf'))) return 'Reconditionné - Excellent état';
    if (normalized === 'etat neuf' || normalized === 'comme neuf') return 'Excellent état';
    return label;
  };
  const brandOptions = brands => {
    const unique = new Map();
    brands.forEach(brand => {
      const rawTag = String(brand.tag || '').trim();
      if (!rawTag) return;
      const key = rawTag.normalize('NFKC').toLowerCase();
      if (!unique.has(key)) unique.set(key, {id:key,label:brand.label,tags:new Set()});
      unique.get(key).tags.add(rawTag);
    });
    return [...unique.values()].map(brand => ({id:brand.id,label:brand.label,rule:brand.tags.size > 1 ? {any:[...brand.tags].map(tag => ({tag}))} : {tag:[...brand.tags][0]}}));
  };
  const term = rule => rule.tag ? `tag:"${rule.tag}"` : rule.all ? `(${rule.all.map(term).join(' AND ')})` : rule.any ? `(${rule.any.map(term).join(' OR ')})` : `-${term(rule.not)}`;
  function init(scope = document) {
    scope.querySelectorAll('[data-ra-catalog]').forEach(el => {
      if (el.dataset.initialized) return;
      el.dataset.initialized = 'true';
      setup(el).catch(() => {
        // Shopify's live product grid remains available if the enhancement cannot load.
        el.querySelector('[data-ra-context-filters]')?.replaceChildren();
      });
    });
  }
  async function setup(el) {
    const url = new URL(location.href);
    const dialog = el.querySelector('[data-ra-filter-dialog]');
    const form = el.querySelector('[data-ra-filter-form]');
    const open = el.querySelector('[data-ra-open-filters]');
    const close = el.querySelector('[data-ra-close-filters]');
    let opener = null;
    open.addEventListener('click', () => { opener = document.activeElement; dialog.showModal(); });
    close.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', e => { if (e.target === dialog) { const b = dialog.getBoundingClientRect(); if (e.clientX < b.left || e.clientX > b.right || e.clientY < b.top || e.clientY > b.bottom) dialog.close(); }});
    dialog.addEventListener('close', () => opener?.focus());
    const nav = await loadNavigation(el.dataset.navigationUrl);
    const nodes = new Map(nav.nodes.map(n => [n.id,n]));
    const category = url.searchParams.get('ra') || url.searchParams.get('ra_category') || el.dataset.category;
    const node = nodes.get(category);
    const parent = node?.parent ? nodes.get(node.parent) : node;
    const preserveCollection = !node && el.dataset.isSearch !== 'true' && el.dataset.collectionHandle && el.dataset.collectionHandle !== 'all';
    const rawQuery = facets.visibleQuery(el.dataset.query || '');
    const userText = url.searchParams.get('ra_text') || (!node && !/\b(tag|product_type|vendor):/.test(rawQuery) ? rawQuery : '');
    const allProductsPath = new URL(el.dataset.allProductsUrl || '/collections/all',location.origin).pathname.replace(/\/$/,'');
    const broadCollectionPath = n => ['jeux-video','tous-jeux'].includes(n?.id) ? `${allProductsPath}/type-jeux-video` : !n ? allProductsPath : null;
    // Shopify search pagination stops at 1,000 matches. Large unfiltered universes
    // use the native all-products collection so every imported item is reachable.
    const nativeBasePath = !userText ? broadCollectionPath(node) || (el.dataset.isSearch !== 'true' && el.dataset.collectionHandle ? location.pathname : null) : null;
    if (node) {
      el.querySelector('[data-ra-title]').textContent = node.label;
      el.querySelector('[data-ra-breadcrumb]').textContent = node.label;
      el.querySelector('[data-ra-description]').textContent = node.description || parent?.description || '';
      el.querySelector('[data-ra-eyebrow]').textContent = node.parent ? (parent?.label || 'LE CATALOGUE') : 'LE CATALOGUE';
      const header = el.querySelector('[data-ra-category-header]');
      const media = el.querySelector('[data-ra-category-media]');
      const photo = el.querySelector('[data-ra-category-image]');
      const scenes = {apple:'ra-banner-apple.webp',samsung:'ra-banner-samsung.webp',gaming:'ra-banner-gaming.webp','jeux-video':'ra-banner-gaming.webp',aspirateurs:'ra-banner-home.webp',audio:'ra-banner-audio.webp'};
      if (header && media && photo) {
        const imageAsset = scenes[node.id] || node.image_asset;
        header.classList.add('ra-catalog__intro--visual');
        header.classList.toggle('ra-catalog__intro--scene', Boolean(scenes[node.id]));
        header.classList.toggle('ra-catalog__intro--dark', ['gaming','jeux-video','audio'].includes(node.id));
        photo.src = (scenes[node.id] ? window.RA?.images?.banners?.[node.id] : window.RA?.images?.categories?.[node.id]) || new URL(imageAsset, new URL(el.dataset.navigationUrl, location.href)).href;
        photo.alt = node.label;
        photo.hidden = false;
        media.hidden = false;
      }
    } else if (userText) {
      el.querySelector('[data-ra-title]').textContent = `Résultats pour « ${userText} »`;
      el.querySelector('[data-ra-breadcrumb]').textContent = 'Recherche';
    }
    // Keep the storefront's human search field readable, even when the URL contains tag expressions.
    if (node) document.querySelectorAll('input[type="search"][name="q"]').forEach(input => { input.value = userText; });
    const children = node ? node.children || [] : (!userText ? nav.root_order : []);
    const sub = el.querySelector('[data-ra-subcollections]');
    const localImage = n => window.RA?.images?.categories?.[n.id] || new URL(n.image_asset || `ra-category-${n.id}.webp`, new URL(el.dataset.navigationUrl, location.href)).href;
    const nodeURL = n => {
      const nativePath = broadCollectionPath(n);
      const link = new URL(nativePath || el.dataset.searchUrl, location.origin);
      if (!nativePath) { link.searchParams.set('type','product'); link.searchParams.set('q', facets.excludeService(n.search_query)); }
      link.searchParams.set('ra',n.id);
      return link.pathname + link.search;
    };
    if (children.length) {
      sub.innerHTML = children.map(id => nodes.get(id)).filter(Boolean).map(n => `<a class="ra-subcollection" href="${escape(nodeURL(n))}"><span class="ra-subcollection__image"><img src="${escape(localImage(n))}" data-fallback="${escape(n.representative?.image_url || '')}" alt="" loading="lazy" width="160" height="140"></span><span>${escape(n.label)}</span><span class="ra-subcollection__arrow" aria-hidden="true">↗</span></a>`).join('');
      sub.hidden = false;
      sub.querySelectorAll('img').forEach(img => img.addEventListener('error', () => { if (img.dataset.fallback) { img.src = img.dataset.fallback; delete img.dataset.fallback; } }, {once:true}));
    }
    const currentGroups = node?.filter_groups?.length ? node.filter_groups : parent?.filter_groups || (preserveCollection ? [] : ['catalog_universe','price','condition','colour','configuration']);
    let groupIds = [...currentGroups];
    if (node?.parent) {
      groupIds = groupIds.filter(g => !['apple_family','samsung_family'].includes(g));
      if (node.source_tags.some(t => t.startsWith('plateforme-'))) groupIds = groupIds.filter(g => g !== 'platform');
      if (node.source_tags.some(t => t.startsWith('marque-'))) groupIds = groupIds.filter(g => !['brand','vacuum_brand','audio_brand'].includes(g));
      if (node.source_tags.some(t => t.startsWith('type-aspirateurs-'))) groupIds = groupIds.filter(g => g !== 'vacuum_type');
    }
    const groupOptions = new Map();
    const container = el.querySelector('[data-ra-context-filters]');
    const nativeOptions = [...el.querySelectorAll('[data-ra-native-filter]')].map(fieldset => fieldset.dataset.raNativeFilter).filter(param => param.startsWith('filter.v.option.')).map(param => param.slice('filter.v.option.'.length));
    const nativeNormalized = new Set(nativeOptions.map(facets.normalize));
    const needsFallback = !preserveCollection && (groupIds.includes('condition') && !nativeNormalized.has('etat') || groupIds.includes('colour') && !nativeNormalized.has('couleur') || groupIds.includes('configuration') && !nativeNormalized.has('configuration'));
    const facetData = needsFallback && el.dataset.facetsUrl ? await loadNavigation(el.dataset.facetsUrl).catch(() => null) : null;
    const fallbackGroups = facets.resolveOptions(facetData, node?.id || 'all', groupIds, nativeOptions);
    const renderGroup = (id,label,options) => {
      if (!options.length) return '';
      groupOptions.set(id,options);
      const selected = new Set(url.searchParams.getAll(`ra_${id}`).flatMap(v => v.split(',')));
      const search = options.length > 12 ? `<input type="search" class="ra-filter-option-search" data-ra-option-search placeholder="Rechercher" aria-label="Rechercher dans ${escape(label)}">` : '';
      return `<fieldset class="ra-filter-group"><legend>${escape(label)}</legend>${search}<div class="ra-filter-options">${options.map(o => `<label class="ra-filter-option"><input type="checkbox" name="ra_${escape(id)}" value="${escape(o.id)}" ${selected.has(o.id)?'checked':''}><span>${escape(conditionLabel(o.label))}</span></label>`).join('')}</div></fieldset>`;
    };
    container.innerHTML = groupIds.map(id => {
      const group = nav.filter_groups[id];
      if (!group || ['native','native_variant_option'].includes(group.kind)) return '';
      let options = [];
      if (group.kind === 'tag') options = group.options.map(o => ({id:o.tag,label:o.label,rule:{tag:o.tag}}));
      if (group.kind === 'rules') options = group.node_ids.map(k => nodes.get(k)).filter(Boolean).map(n => ({id:n.id,label:n.label,rule:n.rule}));
      if (group.kind === 'native_or_contextual_tags') options = brandOptions(node?.brands || parent?.brands || []);
      if (group.kind === 'tag_boolean') options = [{id:'yes',label:group.true_label,rule:{tag:group.tag}},{id:'no',label:group.false_label,rule:{not:{tag:group.tag}}}];
      return renderGroup(id,group.label,options);
    }).join('') + fallbackGroups.map(group => renderGroup(group.id,group.label,group.options)).join('');
    container.querySelectorAll('[data-ra-option-search]').forEach(input => input.addEventListener('input', () => {
      const query = facets.normalize(input.value);
      input.closest('fieldset').querySelectorAll('.ra-filter-option').forEach(label => { label.hidden = !facets.normalize(label.textContent).includes(query); });
    }));
    const error = document.createElement('p');
    error.className = 'ra-filter-error'; error.setAttribute('role','alert'); error.hidden = true;
    form.querySelector('.ra-filter-dialog__body').append(error);
    const nativeInput = (param,value) => [...form.querySelectorAll('input')].find(input => input.name === param && String(input.value) === String(value));
    const selection = () => {
      const values = new FormData(form);
      const clauses = node ? [node.search_query] : [];
      let contextualSelection = false;
      if (userText) clauses.push(`(${userText})`);
      const out = new URL(preserveCollection ? location.pathname : el.dataset.searchUrl, location.origin);
      if (!preserveCollection) out.searchParams.set('type','product');
      if (node) out.searchParams.set('ra',node.id);
      if (userText) out.searchParams.set('ra_text',userText);
      groupOptions.forEach((options,id) => {
        const chosen = values.getAll(`ra_${id}`);
        const rules = options.filter(o => chosen.includes(o.id)).map(o => term(o.rule));
        if (rules.length) { contextualSelection = true; clauses.push(`(${rules.join(' OR ')})`); chosen.forEach(v => out.searchParams.append(`ra_${id}`,v)); }
      });
      if (facetData) {
        const selected = {};
        fallbackGroups.forEach(group => { selected[group.dimension] = values.getAll(`ra_${group.id}`); });
        // Combine fallback selections with any active native variant options.
        values.forEach((value,param) => {
          if (!param.startsWith('filter.v.option.')) return;
          // Stable GIDs may represent grouped native values. Shopify resolves
          // those groups; do not infer their variant membership from the label.
          if (String(value).startsWith('gid:')) return;
          const optionName = facets.normalize(param.slice('filter.v.option.'.length));
          Object.entries(facetData.groups).forEach(([dimension,group]) => {
            if (dimension === 'storage' || dimension === 'ram' || facets.normalize(group.source_option) !== optionName) return;
            const match = facetData.options[dimension].find(option => option.label === value);
            if (match) (selected[dimension] ||= []).push(match.tag);
          });
        });
        const excluded = facets.exactExclusions(facetData,selected);
        if (excluded.length) clauses.push(`-(${excluded.map(tag=>`tag:${facets.quote(tag)}`).join(' OR ')})`);
      }
      values.forEach((v,k) => { if (k.startsWith('filter.') && String(v).trim()) out.searchParams.append(k,v); });
      const useNativeCollection = preserveCollection || Boolean(nativeBasePath && !contextualSelection);
      if (useNativeCollection) { out.pathname = preserveCollection ? location.pathname : nativeBasePath; out.searchParams.delete('type'); }
      else out.searchParams.set('q', facets.excludeService(clauses.length ? clauses.join(' AND ') : '*'));
      const sort = el.querySelector('[data-ra-sort]').value;
      out.searchParams.set('sort_by',useNativeCollection ? (sort === 'relevance' ? 'best-selling' : sort) : ['price-ascending','price-descending','relevance'].includes(sort) ? sort : 'relevance');
      return out;
    };
    const applySelection = () => {
      const target = selection();
      if (target.href.length > 7000) { error.textContent = 'Votre sélection contient trop de critères. Réduisez le nombre d’options cochées.'; error.hidden = false; error.scrollIntoView({block:'nearest'}); return; }
      location.assign(target.href);
    };
    form.addEventListener('submit', e => { e.preventDefault(); applySelection(); });
    el.querySelector('[data-ra-sort]').addEventListener('change', () => {
      const out = new URL(location.href);
      out.searchParams.set('sort_by',el.querySelector('[data-ra-sort]').value); out.searchParams.delete('page'); location.assign(out.href);
    });
    const reset = () => {
      form.querySelectorAll('input[type="checkbox"]').forEach(input => input.checked = false);
      form.querySelectorAll('input[type="number"]').forEach(input => input.value = '');
      container.querySelectorAll('[data-ra-option-search]').forEach(input => { input.value = ''; });
      container.querySelectorAll('.ra-filter-option').forEach(label => { label.hidden = false; });
      error.hidden = true;
    };
    el.querySelector('[data-ra-reset-filters]').addEventListener('click', reset);
    const active = [];
    groupOptions.forEach((options,id) => options.forEach(o => { if (url.searchParams.getAll(`ra_${id}`).flatMap(v => v.split(',')).includes(o.id)) active.push({param:`ra_${id}`,value:o.id,label:o.label}); }));
    url.searchParams.forEach((v,k) => { if (k.startsWith('filter.') && v) active.push({param:k,value:v,label:k.endsWith('.gte') ? `Dès ${v} €` : k.endsWith('.lte') ? `Jusqu’à ${v} €` : conditionLabel(nativeInput(k,v)?.dataset?.raNativeLabel || (v.startsWith('gid:') ? 'Filtre sélectionné' : v))}); });
    const chips = el.querySelector('[data-ra-active-filters]');
    chips.innerHTML = active.map((a,i) => `<button type="button" class="ra-filter-chip" data-remove-filter="${i}" aria-label="Retirer le filtre ${escape(a.label)}">${escape(a.label)}<span aria-hidden="true">×</span></button>`).join('');
    chips.addEventListener('click', e => {
      const button = e.target.closest('[data-remove-filter]'); if (!button) return;
      const a = active[Number(button.dataset.removeFilter)];
      form.querySelectorAll('input').forEach(input => { if (input.name === a.param && String(input.value) === a.value) { if (input.type === 'checkbox') input.checked=false; else input.value=''; }});
      applySelection();
    });
    const badge = el.querySelector('[data-ra-filter-count]');
    badge.textContent = active.length; badge.hidden = !active.length;
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
